import React, { useEffect, useState } from "react";
import { FaCamera } from "react-icons/fa";
import { SubjectErrorBags } from "./SubjectInterface";

interface SubjectImageProps {
  inputChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setErrorBags: React.Dispatch<React.SetStateAction<SubjectErrorBags>>;
  imagestring?: string;
}

export default function SubjectImage({
  inputChangeHandler,
  setFormData,
  setErrorBags,
  imagestring,
}: SubjectImageProps) {
  const [image, setImage] = useState<string | null>(imagestring || null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  useEffect(() => {
    if (imagestring) {
      setImage(imagestring);
    }
  }, [imagestring]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (!file) {
      setImage(null);
      setImageFile(null);
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        image: "",
      }));
      return;
    }
    const validFileTypes = ["image/jpeg", "image/png"];
    if (!validFileTypes.includes(file.type)) {
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        image: "Invalid file type. Only JPG and PNG files are allowed.",
      }));
      return;
    }
    const maxSize = 3 * 1024 * 1024;
    if (file.size > maxSize) {
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        image: "File size exceeds 3MB. Please select a smaller file.",
      }));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result as string);
    };
    reader.readAsDataURL(file);

    setImageFile(file);
    setErrorBags((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
    inputChangeHandler(e);
  };

  return (
    <div className="col-span-1 md:col-span-2">
      <label htmlFor="imageUpload" className="cursor-pointer">
        <div className="rounded-full w-32 h-32 bg-gray-200 flex items-center justify-center overflow-hidden">
          {image ? (
            <img
              src={image}
              alt="Profile"
              className="rounded-full w-32 h-32 object-cover"
            />
          ) : (
            <FaCamera className="text-gray-500 text-2xl" />
          )}
        </div>
        <input
          id="imageUpload"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFileChange}
        />
      </label>
    </div>
  );
}
